import {
    CategoryTag,
    CategoryTrigger,
    DesktopNavMenu as DesktopNavMenuBase,
    MaybeLink,
    type NavCategoryStyle,
    NavItemRichContent,
    NextImage,
} from "@jog/react-components"
import type { PrismicSubCategoryItem, PrismicThirdCategoryItem } from "@jog/shared"

const SubCategoryItem = ({ item }: { item: PrismicSubCategoryItem }) => {
    const style: NavCategoryStyle = { "--text-color": item.subCategoryTextColor || "inherit" }
    return (
        <div className="flex-1">
            <MaybeLink className="flex items-center leading-5" style={style} href={item.subCategoryUrl}>
                <div className="text-13 font-bold text-[var(--text-color)] no-underline group-hover/link:underline">
                    <NavItemRichContent htmlStr={item.subCategoryName} />
                </div>
                <CategoryTag
                    className="text-10"
                    label={item.subLabelText}
                    color={item.subLabelTextColor || ""}
                    backgroundColor={item.subLabelBgColor || ""}
                />
            </MaybeLink>
            <div className="mt-2.5 space-y-3">
                {item.thirdCategoryItems.map((child, index) => (
                    <ThirdCategoryItem key={index} item={child} />
                ))}
            </div>
        </div>
    )
}
const ThirdCategoryItem = ({ item }: { item: PrismicThirdCategoryItem }) => {
    const style: NavCategoryStyle = { "--text-color": item.thirdCategoryTextColor || "inherit" }
    return (
        <MaybeLink className="flex items-center" href={item.thirdCategoryUrl} style={style}>
            <div className="text-13 leading-5 text-[var(--text-color)] no-underline group-hover/link:underline">
                <NavItemRichContent htmlStr={item.thirdCategoryName} />
            </div>
            <CategoryTag
                className="text-10"
                label={item.thirdLabelText}
                color={item.thirdLabelTextColor || ""}
                backgroundColor={item.thirdLabelBgColor || ""}
            />
        </MaybeLink>
    )
}
export const DesktopNavMenu = () => (
    <DesktopNavMenuBase
        Trigger={({ navItem }) => (
            <CategoryTrigger className="h-20 text-13 no-underline decoration-2 hover:underline" navItem={navItem} />
        )}
        MenuContent={({ navItem }) => (
            <div className="flex p-5">
                {navItem.subCategoryItems.map((child, index) => (
                    <SubCategoryItem key={index} item={child} />
                ))}
                {navItem?.bannerImage && navItem.bannerUrl ? (
                    <MaybeLink href={navItem.bannerUrl} className="flex-1" aria-label="Category navigation banner">
                        <NextImage blur={false} width={300} height={300} src={navItem.bannerImage} alt="" />
                    </MaybeLink>
                ) : (
                    <></>
                )}
            </div>
        )}
    />
)
